var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _vm.showTabSelectorComponent &&
    _vm.clonedItems &&
    _vm.clonedItems.length
    ? _c(
        "div",
        { staticClass: "tab-selector-component" },
        [
          _c("button", {
            class: ["tab-selector-button", _vm.buttonIcon],
            attrs: { title: this.text.tooltip, disabled: _vm.disabled },
            on: { click: _vm.btnClick },
          }),
          _c("ejs-contextmenu", {
            staticClass: "tab-selector-contextmenu",
            attrs: {
              id: "tab-selector-contextmenu",
              items: _vm.clonedItems,
              beforeOpen: _vm.beforeOpen,
              beforeClose: _vm.beforeClose,
            },
          }),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }